import styled from 'styled-components'

import { helpers } from 'styles'

export const Lower = styled.span`
	display: block;
	font-size: ${helpers.font.size.baseSmall};
	color: ${helpers.color.textSubtitle};
	text-align: right;
`
